module.exports = __webpack_public_path__ + "img/03_uk.ec2f1e8a.svg";